module.exports = __webpack_public_path__ + "media/Kreative_Ecke-Helena Hauptmenue_Reminder_1a.cc12074b.mp3";